import RobotsRedux from './robots_redux';

export default RobotsRedux;
